import { Route } from '@angular/router';
import { SigningComponent } from './signing.component';

export const SigningRoutes: Route[] = [
  {
    path: 'sign/:code',
    component: SigningComponent
  }
];
